/**
 * ============================================================
 * OROPE PRODUCT PERSONALIZATION (v3.2 - Pack Selector for All)
 * ============================================================
 */

(function () {
  'use strict';

  const MORSE_MAP = {
    A: '·−',     B: '−···',   C: '−·−·',   D: '−··',    E: '·',
    F: '··−·',   G: '−−·',    H: '····',   I: '··',     J: '·−−−',
    K: '−·−',    L: '·−··',   M: '−−',     N: '−·',     O: '−−−',
    P: '·−−·',   Q: '−−·−',   R: '·−·',    S: '···',    T: '−',
    U: '··−',    V: '···−',   W: '·−−',    X: '−··−',   Y: '−·−−',
    Z: '−−··',
    0: '−−−−−',  1: '·−−−−',  2: '··−−−',  3: '···−−',  4: '····−',
    5: '·····',  6: '−····',  7: '−−···',  8: '−−−··',  9: '−−−−·'
  };

  const FONT_MAP = {
    classic: { family: "'Playfair Display', Georgia, serif", weight: '700', label: 'Classic', className: 'is-classic' },
    signature: { family: "'Dancing Script', 'Brush Script MT', cursive", weight: '400', label: 'Signature', className: 'is-signature' },
    swirl: { family: "'Great Vibes', 'Lucida Handwriting', cursive", weight: '400', label: 'Swirl', className: 'is-swirl' }
  };

  function toMorse(text) {
    if (!text) return '';
    return text
      .toUpperCase()
      .split(' ')
      .map(function (word) {
        return word
          .split('')
          .map(function (ch) { return MORSE_MAP[ch] || ''; })
          .filter(Boolean)
          .join(' ');
      })
      .filter(Boolean)
      .join(' / ');
  }

  function validateInput(value, type, maxChars) {
    const trimmed = (value || '').trim();
    if (trimmed.length === 0) {
      return 'Please enter ' + (type === 'morse' ? 'a name to engrave' : 'your name');
    }
    if (trimmed.length > maxChars) {
      return 'Maximum ' + maxChars + ' characters allowed';
    }
    if (type === 'morse') {
      if (!/^[A-Za-z0-9 ]+$/.test(trimmed)) {
        return 'Only letters, numbers and spaces allowed';
      }
    } else {
      if (!/^[A-Za-z0-9 .'\-]+$/.test(trimmed)) {
        return 'Only letters, numbers, spaces, hyphens and apostrophes allowed';
      }
    }
    return null;
  }

  function initWrapper(wrapper) {
    if (wrapper.dataset.oropeInit === '1') return;
    wrapper.dataset.oropeInit = '1';

    const type = wrapper.dataset.engravingType;
    const maxChars = parseInt(wrapper.dataset.maxChars, 10) || 10;
    const isName = type === 'name';

    const inputsContainer = wrapper.querySelector('[data-personalization-inputs]');
    const quantityInfo = wrapper.querySelector('[data-quantity-info]');
    const quantityInfoText = wrapper.querySelector('[data-quantity-info-text]');

    const form = wrapper.closest('form[action*="/cart/add"]') ||
                 wrapper.closest('form[action$="/cart/add"]');

    // -------- Pack Selector — ALL PRODUCTS --------
    let selectedPack = 1;
    const packSelector = wrapper.querySelector('[data-pack-selector]');

    if (packSelector) {
      const packOptions = packSelector.querySelectorAll('[data-pack]');

      packOptions.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const pack = parseInt(btn.dataset.pack, 10);
          selectedPack = pack;

          packOptions.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          syncInputsToPack(pack);

          // Update hidden quantity input
          const qtyInput = getQuantityInput();
          if (qtyInput) {
            qtyInput.value = pack;
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          console.log('[Orope] Pack selected:', pack);
        });
      });
    }

    function getQuantityInput() {
      if (!form) return null;
      return form.querySelector('input[name="quantity"]') ||
             form.querySelector('#Quantity') ||
             form.querySelector('[data-quantity-input]') ||
             form.querySelector('.quantity__input') ||
             form.querySelector('input.product-form__quantity');
    }

    function updatePreview(value, previewContent, fontClass) {
      const trimmed = (value || '').trim();
      if (!trimmed) {
        previewContent.innerHTML = type === 'morse'
          ? '<span class="orope-personalization__preview-placeholder">- - · · ·</span>'
          : '<span class="orope-personalization__preview-placeholder">Her Name</span>';
        return;
      }
      if (type === 'morse') {
        previewContent.textContent = toMorse(trimmed);
      } else {
        previewContent.textContent = trimmed;
        previewContent.classList.remove('is-classic', 'is-signature', 'is-swirl');
        if (fontClass) {
          previewContent.classList.add(fontClass);
        }
      }
    }

    function bindInputGroup(group) {
      const input = group.querySelector('[data-personalization-input]');
      const counterCurrent = group.querySelector('[data-counter-current]');
      const counter = group.querySelector('[data-counter]');
      const errorEl = group.querySelector('[data-error]');
      const morseHidden = group.querySelector('[data-morse-output]');
      const previewContent = group.querySelector('[data-preview-content]');
      const fontInput = group.querySelector('[data-font-style-input]');

      function updateCounter() {
        const len = input.value.length;
        counterCurrent.textContent = len;
        counter.classList.remove('is-near-limit', 'is-at-limit');
        if (len >= maxChars) counter.classList.add('is-at-limit');
        else if (len >= maxChars - 2) counter.classList.add('is-near-limit');
      }

      function clearError() {
        errorEl.hidden = true;
        errorEl.textContent = '';
        input.classList.remove('is-invalid');
      }

      function showError(msg) {
        errorEl.hidden = false;
        errorEl.textContent = msg;
        input.classList.add('is-invalid');
      }

      // Font selector within this group (name products only)
      const fontSelector = group.querySelector('[data-font-selector]');
      if (fontSelector && isName) {
        const fontOptions = fontSelector.querySelectorAll('[data-font]');

        fontOptions.forEach(function (btn) {
          btn.addEventListener('click', function () {
            const font = btn.dataset.font;

            fontOptions.forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');

            if (fontInput) {
              fontInput.value = FONT_MAP[font].label;
            }

            updatePreview(input.value, previewContent, FONT_MAP[font].className);
          });
        });
      }

      input.addEventListener('input', function () {
        if (input.value.length > maxChars) {
          input.value = input.value.slice(0, maxChars);
        }
        updateCounter();
        clearError();

        if (type === 'morse' && morseHidden) {
          morseHidden.value = toMorse(input.value);
        }

        let fontClass = '';
        if (fontSelector) {
          const activeFont = fontSelector.querySelector('.is-active');
          if (activeFont) {
            fontClass = FONT_MAP[activeFont.dataset.font].className;
          }
        }
        updatePreview(input.value, previewContent, fontClass);
      });

      input.addEventListener('blur', function () {
        const err = validateInput(input.value, type, maxChars);
        if (err && input.value.trim().length > 0) {
          showError(err);
        }
      });

      updateCounter();
    }

    // Bind initial group
    inputsContainer.querySelectorAll('[data-input-group]').forEach(bindInputGroup);

    // -------- Column layout: sync inputs to pack size --------
    function syncInputsToPack(packSize) {
      packSize = Math.max(1, parseInt(packSize, 10) || 1);

      const existingGroups = inputsContainer.querySelectorAll('[data-input-group]');
      const currentCount = existingGroups.length;

      console.log('[Orope] syncInputsToPack. packSize=' + packSize + ', currentCount=' + currentCount);

      if (packSize > currentCount) {
        for (let i = currentCount; i < packSize; i++) {
          const newGroup = createInputGroup(i);
          inputsContainer.appendChild(newGroup);
          bindInputGroup(newGroup);
          console.log('[Orope] Added input group ' + i);
        }
      } else if (packSize < currentCount) {
        for (let i = currentCount - 1; i >= packSize; i--) {
          existingGroups[i].remove();
        }
      }

      // Update labels
      const groups = inputsContainer.querySelectorAll('[data-input-group]');
      groups.forEach(function (g, idx) {
        const label = g.querySelector('[data-slide-label]');
        if (label) {
          label.textContent = 'Necklace ' + (idx + 1) + ' Name';
          label.hidden = false;
        }
      });

      // Show/hide quantity info
      if (packSize > 1) {
        quantityInfo.hidden = false;
        quantityInfoText.textContent = 'You\'re ordering ' + packSize + ' items — enter a different ' + (isName ? 'name' : 'engraving') + ' for each.';
      } else {
        quantityInfo.hidden = true;
      }
    }

    function createInputGroup(index) {
      const group = document.createElement('div');
      group.className = 'orope-personalization__input-group';
      group.setAttribute('data-input-group', '');
      group.setAttribute('data-index', String(index));

      const placeholder = type === 'morse' ? 'e.g. PRIYA' : 'Enter name...';
      const labelText = 'Necklace ' + (index + 1) + ' Name';

      let fontSelectorHTML = '';
      if (isName) {
        fontSelectorHTML = 
          '<div class="orope-font-selector" data-font-selector>' +
            '<div class="orope-font-selector__options">' +
              '<button type="button" class="orope-font-option is-active" data-font="classic">' +
                '<span class="orope-font-option__preview" style="font-family: \'Playfair Display\', Georgia, serif; font-weight: 700;">Priya</span>' +
                '<span class="orope-font-option__label">Classic</span>' +
              '</button>' +
              '<button type="button" class="orope-font-option" data-font="signature">' +
                '<span class="orope-font-option__preview" style="font-family: \'Dancing Script\', \'Brush Script MT\', cursive;">Priya</span>' +
                '<span class="orope-font-option__label">Signature</span>' +
              '</button>' +
              '<button type="button" class="orope-font-option" data-font="swirl">' +
                '<span class="orope-font-option__preview" style="font-family: \'Great Vibes\', \'Lucida Handwriting\', cursive;">Priya</span>' +
                '<span class="orope-font-option__label">Swirl</span>' +
              '</button>' +
            '</div>' +
            '<input type="hidden" name="properties[Font Style]" data-font-style-input value="Classic">' +
          '</div>';
      }

      let previewHTML = 
        '<div class="orope-personalization__preview" data-preview-wrapper>' +
          '<div class="orope-personalization__preview-label">Preview:</div>' +
          '<div class="orope-personalization__preview-content" data-preview-content>' +
            (type === 'morse' 
              ? '<span class="orope-personalization__preview-placeholder">- - · · ·</span>'
              : '<span class="orope-personalization__preview-placeholder">Her Name</span>') +
          '</div>' +
          (type === 'morse'
            ? '<div class="orope-personalization__preview-helper"><span data-preview-source></span></div>'
            : '<div class="orope-personalization__preview-helper"><span data-preview-hint>✨ How her necklace will look</span></div>') +
        '</div>';

      group.innerHTML =
        '<div class="orope-personalization__slide-label" data-slide-label>' + labelText + '</div>' +
        '<div class="orope-personalization__input-row">' +
          '<input type="text" ' +
            'name="properties[Engraving]" ' +
            'class="orope-personalization__input" ' +
            'data-personalization-input ' +
            'data-index="' + index + '" ' +
            'placeholder="' + placeholder + '" ' +
            'maxlength="' + maxChars + '" ' +
            'autocomplete="off" spellcheck="false" required>' +
          '<span class="orope-personalization__counter" data-counter aria-live="polite">' +
            '<span data-counter-current>0</span>/<span data-counter-max>' + maxChars + '</span>' +
          '</span>' +
        '</div>' +
        (type === 'morse'
          ? '<input type="hidden" name="properties[Morse Code]" data-morse-output value="">'
          : '') +
        '<div class="orope-personalization__error" data-error hidden role="alert"></div>' +
        fontSelectorHTML +
        previewHTML;

      return group;
    }

    // Initialize with pack size 1 for ALL products
    syncInputsToPack(1);

    // -------- Validation --------
    function getInputGroups() {
      return inputsContainer.querySelectorAll('[data-input-group]');
    }

    function validateAllInputs() {
      const groups = getInputGroups();
      let valid = true;
      let firstInvalid = null;

      groups.forEach(function (g) {
        const input = g.querySelector('[data-personalization-input]');
        const errorEl = g.querySelector('[data-error]');
        const err = validateInput(input.value, type, maxChars);

        if (err) {
          valid = false;
          input.classList.add('is-invalid');
          errorEl.hidden = false;
          errorEl.textContent = err;
          if (!firstInvalid) firstInvalid = input;
        } else {
          input.classList.remove('is-invalid');
          errorEl.hidden = true;
          errorEl.textContent = '';
          if (type === 'morse') {
            const morseHidden = g.querySelector('[data-morse-output]');
            if (morseHidden) morseHidden.value = toMorse(input.value);
          }
        }
      });

      return { valid: valid, firstInvalid: firstInvalid };
    }

    // -------- Form & button interception --------
    if (form) {
      form.addEventListener('submit', function (e) {
        const result = validateAllInputs();
        if (!result.valid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (result.firstInvalid) {
            setTimeout(function () { result.firstInvalid.focus(); }, 100);
          }
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        const groups = getInputGroups();
        if (groups.length > 1) {
          e.preventDefault();
          e.stopImmediatePropagation();
          submitAsMultipleLineItems(groups);
        }
      }, true);

      document.addEventListener('click', function (e) {
        const btn = e.target.closest(
          'button[name="add"], ' +
          '#sticky-add-to-cart, ' +
          '#gokwik-buy-now, ' +
          '[id^="gokwik-buy-now"], ' +
          '.gokwik-buy-now, ' +
          '.shopify-payment-button__button, ' +
          '.shopify-payment-button button, ' +
          '[data-buy-now], ' +
          '.product-form__buynow button, ' +
          '.product-form__buynow a, ' +
          '.product-form__cart-submit'
        );
        if (!btn) return;

        const insideOurForm = form.contains(btn);
        const isKnownExternal =
          btn.id === 'sticky-add-to-cart' ||
          btn.id === 'gokwik-buy-now' ||
          btn.classList.contains('gokwik-buy-now') ||
          (btn.id && btn.id.indexOf('gokwik-buy-now') === 0) ||
          btn.classList.contains('shopify-payment-button__button') ||
          (btn.closest && btn.closest('.shopify-payment-button')) ||
          (btn.closest && btn.closest('.product-form__buynow'));

        if (!insideOurForm && !isKnownExternal) return;

        const result = validateAllInputs();
        if (!result.valid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          if (result.firstInvalid) {
            setTimeout(function () { result.firstInvalid.focus(); }, 100);
          }
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        const isBuyNow =
          btn.id === 'gokwik-buy-now' ||
          btn.classList.contains('gokwik-buy-now') ||
          btn.classList.contains('shopify-payment-button__button') ||
          (btn.closest && btn.closest('.shopify-payment-button')) ||
          (btn.closest && btn.closest('.product-form__buynow')) ||
          (btn.id && btn.id.indexOf('gokwik-buy-now') === 0);

        const groups = getInputGroups();

        if (isBuyNow) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          buyNowViaGokwik(groups, btn);
          return;
        }

        if (groups.length > 1) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          submitAsMultipleLineItems(groups, btn);
          return;
        }
      }, true);
    }

    function getVariantId() {
      const variantInput = form.querySelector('input[name="id"]:not([disabled])') ||
                           form.querySelector('select[name="id"]:not([disabled])');
      return variantInput ? variantInput.value : null;
    }

    // One line item per necklace, each carrying its own engraving properties.
    function buildLineItems(groups, variantId) {
      const items = [];
      for (let i = 0; i < groups.length; i++) {
        const inp = groups[i].querySelector('[data-personalization-input]');
        const text = (inp.value || '').trim();
        const properties = { Engraving: text };

        if (type === 'morse') {
          properties['Morse Code'] = toMorse(text);
        }

        if (isName) {
          const fontInput = groups[i].querySelector('[data-font-style-input]');
          if (fontInput) {
            properties['Font Style'] = fontInput.value;
          }
        }

        items.push({ id: Number(variantId), quantity: 1, properties: properties });
      }
      return items;
    }

    async function addItemsToCart(items) {
      // Sequential so the necklaces keep their order in the cart.
      for (let i = 0; i < items.length; i++) {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: [items[i]] })
        });

        if (!res.ok) {
          const errBody = await res.text();
          throw new Error('Cart add failed: ' + errBody);
        }
      }
    }

    // -------- Buy Now: always through the Gokwik checkout --------
    function isGokwikReady() {
      return typeof window.onBuyNowClick === 'function' &&
             !!window.gokwikSdk &&
             typeof window.gokwikSdk.triggerLoadingScreen === 'function';
    }

    function waitForGokwik(timeoutMs) {
      return new Promise(function (resolve) {
        if (isGokwikReady()) { resolve(true); return; }
        const started = Date.now();
        const timer = setInterval(function () {
          if (isGokwikReady()) {
            clearInterval(timer);
            resolve(true);
          } else if (Date.now() - started >= timeoutMs) {
            clearInterval(timer);
            resolve(false);
          }
        }, 150);
      });
    }

    function resolveGokwikButton(clickedButton) {
      if (clickedButton && clickedButton.id && clickedButton.id.indexOf('gokwik-buy-now') === 0) {
        return clickedButton;
      }
      return form.querySelector('#gokwik-buy-now') || document.getElementById('gokwik-buy-now') || clickedButton;
    }

    let buyNowInFlight = false;

    async function buyNowViaGokwik(groups, clickedButton) {
      if (buyNowInFlight) return;

      const variantId = getVariantId();
      if (!variantId) {
        console.error('[Orope] Could not find variant ID input');
        alert('Sorry, something went wrong. Please refresh and try again.');
        return;
      }

      const items = buildLineItems(groups, variantId);
      buyNowInFlight = true;

      try {
        const ready = await waitForGokwik(5000);

        if (ready) {
          // Gokwik's own buy-now entry point. Given a product list it parks the
          // visitor's current cart, adds exactly these line items (engraving
          // properties included), opens the Gokwik checkout, and restores the
          // parked cart if the checkout is closed. It also drives the button's
          // loader, so the button markup must be left untouched here.
          window.onBuyNowClick(resolveGokwikButton(clickedButton), false, items);
          return;
        }

        // Gokwik did not load. Never fall through to Shopify's /checkout:
        // put the necklaces in the cart and continue from the cart page,
        // where the Gokwik checkout button lives.
        console.warn('[Orope] Gokwik not available, continuing via cart page');
        await addItemsToCart(items);
        window.location.href = '/cart';
      } catch (err) {
        console.error('[Orope] Buy now failed:', err);
        alert('Sorry, something went wrong. Please try again.');
      } finally {
        setTimeout(function () { buyNowInFlight = false; }, 1500);
      }
    }

    async function submitAsMultipleLineItems(groups, clickedButton) {
      const variantId = getVariantId();
      if (!variantId) {
        console.error('[Orope] Could not find variant ID input');
        alert('Sorry, something went wrong. Please refresh and try again.');
        return;
      }

      const submitBtn = clickedButton ||
                         form.querySelector('[type="submit"]') ||
                         form.querySelector('[name="add"]');
      let originalText = '';
      if (submitBtn) {
        originalText = submitBtn.innerHTML;
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.6';
        submitBtn.style.pointerEvents = 'none';
        if (submitBtn.tagName === 'BUTTON') {
          submitBtn.innerHTML = 'Adding...';
        }
      }

      try {
        await addItemsToCart(buildLineItems(groups, variantId));

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));

        try {
          const cartRes = await fetch('/cart.js');
          const cartData = await cartRes.json();
          document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count, .js-cart-count').forEach(function (el) {
            el.textContent = cartData.item_count;
          });
        } catch (e) { /* non-fatal */ }

        setTimeout(function () {
          if (!document.body.classList.contains('drawer-open') &&
              !document.body.classList.contains('cart-drawer-open') &&
              !document.querySelector('.cart-drawer.is-open, cart-drawer[open], .js-mini-cart.active')) {
            window.location.href = '/cart';
          } else {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.style.opacity = '';
              submitBtn.style.pointerEvents = '';
              if (submitBtn.tagName === 'BUTTON') submitBtn.innerHTML = originalText;
            }
          }
        }, 500);
      } catch (err) {
        console.error('[Orope] Multi-quantity ATC failed:', err);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '';
          submitBtn.style.pointerEvents = '';
          if (submitBtn.tagName === 'BUTTON') submitBtn.innerHTML = originalText;
        }
        alert('Sorry, something went wrong. Please try again.');
      }
    }

    if (!window.__oropeFetchPatched) {
      window.__oropeFetchPatched = true;
      const origFetch = window.fetch;
      window.fetch = function (url, options) {
        try {
          const u = (typeof url === 'string') ? url : (url && url.url) || '';
          if (u.indexOf('/cart/add') !== -1 && options && options.method &&
              options.method.toUpperCase() === 'POST') {
            const activeWrappers = document.querySelectorAll('[data-personalization-wrapper]');
            for (let i = 0; i < activeWrappers.length; i++) {
              const w = activeWrappers[i];
              if (w.offsetParent === null) continue;
              const f = w.closest('form[action*="/cart/add"]');
              if (!f) continue;
              const groups = w.querySelectorAll('[data-input-group]');
              for (let j = 0; j < groups.length; j++) {
                const inp = groups[j].querySelector('[data-personalization-input]');
                const err = validateInput(inp.value, w.dataset.engravingType,
                                          parseInt(w.dataset.maxChars, 10));
                if (err) {
                  inp.classList.add('is-invalid');
                  const errEl = groups[j].querySelector('[data-error]');
                  errEl.hidden = false;
                  errEl.textContent = err;
                  inp.focus();
                  w.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  return Promise.reject(new Error('Personalization required'));
                }
              }
            }
          }
        } catch (err) { /* swallow */ }
        return origFetch.apply(this, arguments);
      };
    }
  }

  function initAll() {
    document.querySelectorAll('[data-personalization-wrapper]').forEach(initWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reload', initAll);

  window.OropePersonalization = {
    toMorse: toMorse,
    validate: validateInput,
    reinit: initAll,
    version: 'v3.3-2026-09-22',
    fonts: FONT_MAP
  };
})();